/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';

export async function getSoftwares() {
  const response = await fetch(URLs.getSoftwares());
  const data = await response.json();
  return data;
}
